<template>
  <b-card class="body-card" header-bg-variant="light">
    <b-card-header class="card-header-wrapper">
      <div class="title-wrapper">
        <span class="list-header">ImpaxRx Case Management</span>
        <div class="btn-add-case">
          <b-button variant="success" @click="showQuickAddEditModal">Add Case</b-button>
        </div>
        <div class="btn-filter-wrapper">
          <b-button @click="clearFilter" class="btn-filters">Clear filters</b-button>
          <b-button @click="exportToCsv" class="btn-csv">Export to CSV</b-button>
        </div>
        <download-csv
          v-if="cases"
          style="visibility :hidden"
          name="cases.csv"
          ref="exportCsv"
          :data="cases"
        />
      </div>
    </b-card-header>
    <b-card-body class="card-body-wrapper">
      <b-card class="card-wrapper" header-bg-variant="dark" header="Cases">
        <grid
          v-if="cases"
          :has-clear="false"
          :has-cases-grid="true"
          :has-head-filters="true"
          has-edit
          has-pagination
          grid-id="cases-grid"
          :fields="fields"
          :items="cases"
          :get-items-function="getCasesData"
          :filters="filtersObjArr"
          :total-rows="casePaging.totalItems"
          :current-page="casePaging.pageNumber"
          :per-page="casePaging.pageSize"
          :sort-by="casePaging.sortBy"
          :sort-order="casePaging.sortOrder"
          :no-records="'No case found'"
          ref="casesGridRef"
          @click-row="onRowClick($event)"
        />
      </b-card>
    </b-card-body>
  </b-card>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Grid from '@/shared/components/Grid';
import { convertToFormSelectObj } from '@/shared/utils';
// import QuickEdit from './components/Edit/components/QuickEdit';

export default {
  components: {
    // QuickEdit,
    Grid
  },
  data() {
    return {
      fields: [
        {
          key: 'caseNumber',
          label: 'Case No',
          tdClass: 'txt-link'
        },
        {
          key: 'admin123agentid',
          label: 'Admin123'
        },
        {
          key: 'caseName',
          label: 'Case Company Name'
        },
        {
          key: 'caseStatus',
          label: 'Case Status'
        },
        {
          key: 'channel',
          label: 'Channel'
        },
        {
          key: 'ownerProducer',
          label: 'Owner/Producer'
        },
        {
          key: 'contractDate',
          label: 'Contracted',
          formatter: 'dateFormatter'
        },
        {
          key: 'contractExecutedDate',
          label: 'Executed',
          formatter: 'dateFormatter'
        },
        {
          key: 'enrollmentBy',
          label: 'Type'
        },
        {
          key: 'enrollmentStartDate',
          label: 'Start',
          formatter: 'dateFormatter'
        },
        {
          key: 'enrollmentEndDate',
          label: 'End',
          formatter: 'dateFormatter'
        },
        {
          key: 'startDateProposed',
          label: 'Proposed',
          formatter: 'dateFormatter'
        },
        {
          key: 'startDateActual',
          label: 'Actual',
          formatter: 'dateFormatter'
        }
      ],
      filtersObjArr: [],
      formSelect: {
        caseStatusValues: [],
        caseChannelValues: []
      }
    };
  },
  watch: {},
  computed: {
    ...mapState('cases', ['cases', 'casePaging', 'caseStatus', 'channels'])
  },
  methods: {
    ...mapActions('cases', [
      'getCases',
      'getCaseStatus',
      'getCasesList',
      'getChannels'
    ]),

    async getCasesData(data) {
      await this.getCasesList(data);
    },

    showQuickAddEditModal() {
      //   this.caseId = 0;
      //   this.$refs['quickAddEditModal'].show();
    },

    onRowClick(item) {
      this.$router.push(`/cases/${item.caseId}`);
    },

    async clearFilter() {
      await this.$refs['casesGridRef'].onClearSearch();
    },

    exportToCsv() {
      this.$refs.exportCsv.$el.click();
    }
  },

  async created() {
    let loader = this.$loading.show();
    //do initial api calls here

    await this.getCaseStatus();

    await this.getChannels();

    loader.hide();

    this.formSelect.caseStatusValues = convertToFormSelectObj(this.caseStatus, {
      value: 'id',
      text: 'val'
    });

    this.formSelect.caseStatusValues.unshift({
      value: '',
      text: 'Select Case Status'
    });

    this.formSelect.caseChannelValues = convertToFormSelectObj(this.channels, {
      value: 'id',
      text: 'name'
    });

    this.formSelect.caseChannelValues.unshift({
      value: '',
      text: 'Select Channel'
    });

    this.filtersObjArr = [
      {
        type: 'search',
        name: 'Case No',
        fieldName: 'caseNumber'
      },
      { type: 'search', name: 'Admin123', fieldName: 'admin123' },
      {
        type: 'search',
        name: 'Case Company Name',
        fieldName: 'caseName'
      },
      {
        type: 'select',
        name: 'Case Status',
        fieldName: 'caseStatusId',
        width: '200px',
        options: this.formSelect.caseStatusValues,
        value: '',
        defaultValue: ''
      },
      {
        type: 'select',
        name: 'Channel',
        fieldName: 'companyChannelId',
        width: '120px',
        options: this.formSelect.caseChannelValues,
        value: '',
        defaultValue: ''
      },
      { type: 'search', name: 'Owner/Producer', fieldName: 'ownerProducer' },
      {
        type: 'label',
        name: 'MSA',
        fieldName: 'msa',
        colSpanNumber: '2',
        thClass: 'text-center'
      },
      {
        type: 'label',
        name: 'Enrollment',
        fieldName: 'enrollment',
        colSpanNumber: '3',
        thClass: 'text-center'
      },
      {
        type: 'label',
        name: 'Start',
        fieldName: 'start',
        colSpanNumber: '2',
        thClass: 'text-center'
      }
    ];
  }
};
</script>

<style scoped>
.btn-add-case {
  grid-column: 2/5;
}
</style>